// extracted by mini-css-extract-plugin
export default {"ForumSearch__headline":"py_a bhg_sl bhg_uy","ForumSearch__img":"py_b","ForumSearch__searchAdsAndShoppingAds":"py_c","ForumSearch__results--empty":"py_e"};